module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Interselect-d62d52a8895e20dc89a6a14490fb5e81.svg";